// src/components/common/FabButton.js
import React from 'react';
import { Plus } from 'lucide-react';

const FabButton = ({ onClick, title, icon, visible = true, disabled = false }) => {
    if (!visible) return null;

    return (
        <button
            type="button"
            className="fab-btn"
            onClick={onClick}
            title={title}
            aria-label={title}
            disabled={disabled}
        >
            {icon ? (
                <>
                    {React.cloneElement(icon, { size: 22, className: 'fab-context-icon', 'aria-hidden': true })}
                    <Plus size={15} className="fab-plus-icon" aria-hidden="true" />
                </>
            ) : (
                <Plus size={26} className="icon" aria-hidden="true" />
            )}
        </button>
    );
};

export default FabButton;
